import { makeAutoObservable } from 'mobx';
import path from 'path';
import S3File, { getFirstVolumeFileName, S3FileDto } from './S3File';

export default class S3Files {
  exists!: boolean;
  items: S3File[] = [];
  isEmpty!: boolean;
  name!: string;
  url!: string;

  autoVolumesSelection = true;

  constructor({ children, originalUrl, ...dto }: S3RootDto) {
    Object.assign(this, dto);

    this.items = children.map((childDto) => {
      const url = childDto.url || '';

      const isSelected =
        !url.endsWith('/') && areUrlPathsEqual(url, originalUrl || '');

      return new S3File({ ...childDto, isSelected }, this);
    });

    makeAutoObservable(this, {}, { autoBind: true });
  }

  get selected(): S3File[] {
    return this.items.filter((file) => file.isSelected);
  }

  findByName(fileName: string): S3File | undefined {
    return this.items.find((file) => file.name === fileName);
  }

  filterAnotherVolumes(fileName: string): S3File[] {
    const baseName = path.basename(fileName);
    const firstVolumeName = getFirstVolumeFileName(baseName.toLowerCase());
    return this.items.filter(
      (f) => f.firstVolumeName === firstVolumeName && baseName !== f.name,
    );
  }

  onFileToggled(file: S3File) {
    if (!file.isSelected || !this.autoVolumesSelection) {
      return;
    }

    this.filterAnotherVolumes(file.name).forEach((f) =>
      f.setSelected(true, false),
    );
  }
}

export interface S3RootDto {
  children: S3FileDto[];
  exists: boolean;
  name: string;
  originalUrl?: string;
  url: string;
}

function areUrlPathsEqual(url1: string, url2: string): boolean {
  try {
    const path1 = new URL(url1).pathname;
    const path2 = new URL(url2).pathname;
    return path1 === path2;
  } catch {
    return false;
  }
}
